import { Pipe, PipeTransform } from '@angular/core';

// Mapa de nombres de división PARA MOSTRAR (visual). No cambia el valor real
// que se guarda/envía al backend; solo cambia la etiqueta que ve el usuario.
export const NOMBRE_DIVISION_DISPLAY: { [division: string]: string } = {
  Residencial: 'Residencial Gas',
};

// Traduce el valor de división a su nombre visual. Si no hay mapeo, devuelve
// el valor original tal cual.
export function nombreDivisionDisplay(division?: string | null): string {
  if (!division) return '';
  return NOMBRE_DIVISION_DISPLAY[division] ?? division;
}

@Pipe({
  name: 'nombreDivision',
  standalone: true,
})
export class NombreDivisionPipe implements PipeTransform {
  transform(value?: string | null): string {
    return nombreDivisionDisplay(value);
  }
}
